package club.srams.website.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.navigation.BasePath
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Source
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Video

@Composable
fun KobwebVideoPlayer(
    videoUrl: String,
    modifier: Modifier = Modifier,
    mimeType: String = "video/mp4",
    posterUrl: String? = null,
    autoPlay: Boolean = false,
    muted: Boolean = false,
    loop: Boolean = false,
) {
    // Combine base styling rules with any incoming layout modifiers
    val finalModifier = Modifier
        .width(100.percent)
        .height(350.px)
        .borderRadius(8.px)
        .then(modifier)

    Video(
        attrs = finalModifier.toAttrs {
            // Apply native HTML5 video player elements
            attr("controls", "")
            attr("playsinline", "")
            if (autoPlay) attr("autoplay", "")
            if (muted) attr("muted", "")
            if (loop) attr("loop", "")
            if (posterUrl != null) {
                attr("poster", BasePath.prependTo(posterUrl))
            }
        }
    ) {
        Source(
            attrs = {
                // Prepend base path so asset routes resolve post-export/build
                attr("src", BasePath.prependTo(videoUrl))
                attr("type", mimeType)
            }
        )
        Text("Your browser does not support the video tag.")
    }
}
